import { useState } from "react"
import { toast } from 'react-hot-toast';
import Loader from "../../Components/Common/Loader";
import SystemModal from "../../Components/Common/SystemModal";
import ajaxCard from "../../util/remote/ajaxCard";


const EmergencyCardUpdate=(props)=>{

    const [loading, setLoading] = useState(false)
    const [cardNumber,setCardNumber] =useState("")
    const [password,setPassword] =useState("")

    const data = {
        student_id: props.studentID,
        new_card_number: cardNumber,
        secure_string: password,
      };

    const handleUpdate = async(e) =>{
        e.preventDefault()
        setLoading(true)
        const server_response = await ajaxCard.emergencyCardUpdate(data);
        setLoading(false);
        if(server_response.status==="OK"){
            toast.success(server_response.message);
            props.getAllCards(props.page)
        }
        else{
            toast.error(server_response.message); 
        } 
    }
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleUpdate}>Confirm<i class="fas fa-check mg-l-15"></i></button>
                    </>
        }
    }

    return(
        <SystemModal
            title="Emergency Update"
            id="model-card-emergency"
            size="md"
            footer={RenderFooter}
        >

        <div className="mb-4 form-group border-1">
            <label htmlFor="">New Card / Wristband Number:<span style={{color:"red"}}>*</span> </label>
            <input onChange={(e)=>setCardNumber(e.target.value)} placeholder="Enter new card or wristband number..." style={{border: "1px solid grey"}} value={cardNumber} type="text" className="form-control"/>
        </div>

        <div className="mb-4 form-group border-1">
            <label htmlFor="">Admin Password:<span style={{color:"red"}}>*</span> </label>
            <input onChange={(e)=>setPassword(e.target.value)} placeholder="Enter password provided by the administrator..." style={{border: "1px solid grey"}} value={password} type="password" className="form-control"/>
        </div>
       
        </SystemModal>
    )
}

export default EmergencyCardUpdate
